<template>
  <div class="daily-text-access">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <select
                      v-model="filter.magazine_id"
                      id
                      class="form-control"
                    >
                      <option value="0">Todos os boletins</option>
                      <option
                        v-for="magazine in magazines"
                        :value="magazine.id"
                        v-bind:key="magazine.id"
                      >
                        {{ magazine.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div
                    class="d-flex justify-content-center align-items-center form-group-edit"
                  >
                    <label for>De</label>
                    <b-form-datepicker
                      id="start-datepicker"
                      v-model="filter.start_date"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div
                    class="d-flex justify-content-center align-items-center form-group-edit"
                  >
                    <label for>Até</label>
                    <b-form-datepicker
                      id="end-datepicker"
                      v-model="filter.end_date"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <select v-model="filter.client_id" id class="form-control">
                      <option value="0">Todos os clientes</option>
                      <option
                        v-for="client in clients"
                        :value="client.id"
                        v-bind:key="client.id"
                      >
                        {{ client.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-8">
                  <button
                    class="btn btn-primary float-right"
                    v-on:click="providerData()"
                  >
                    Pesquisar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <table class="default-table">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Texto</th>
                        <th>Boletins</th>
                        <th>Visualizações</th>
                      </tr>
                    </thead>
                    <tbody v-for="item in data" v-bind:key="item.date">
                      <tr class="main-tr">
                        <td>{{ formatDate(item.date) }}</td>
                        <td colspan="2">
                          Total de Textos Acessados: {{ item.texts.length }}
                        </td>
                        <td class="td-center">{{ getDayTotalAccess(item) }}</td>
                      </tr>
                      <tr
                        class="tr-hovered"
                        v-for="row in item.texts"
                        v-bind:key="row.id"
                      >
                        <td>{{ row.hour }}</td>
                        <td>
                          Cód. {{ row.id }} -
                          <b>{{ row.title }}</b>
                          <br />
                          {{ row.user_access.name }}
                          {{
                            row.user_access.client
                              ? `(${row.user_access.client.name})`
                              : ""
                          }}
                        </td>
                        <td>
                          <span
                            v-for="(magazine, index) in row.magazines"
                            v-bind:key="index"
                            >{{
                              magazine.name +
                              (index != row.magazines.length - 1 ? ", " : "")
                            }}</span
                          >
                        </td>
                        <td class="td-center">{{ row.count_access }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import moment from "moment";

export default {
  name: "daily-text-access",
  data() {
    return {
      items: [
        {
          text: "Relatório de textos acessados",
          active: true,
        },
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      data: [],
      magazines: [],
      clients: [],
      filter: {
        magazine_id: 0,
        client_id: 0,
        start_date: "",
        end_date: "",
      },
    };
  },
  mounted() {
    this.filter.end_date = moment().format();
    this.filter.start_date = moment().subtract(7, "days").format();
    this.getSavedData()
    this.getCreateParams();
  },
  methods: {
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/get_daily_text_access?${this.urlBuild()}`
        )
        .then((response) => {
          this.data = response.data;
          bus.$emit("changeLoading", false);
        });
    },
    getSavedData: function () {
      if (
        localStorage.getItem("filters_search_daily_text_access") != null &&
        localStorage.getItem("filters_search_daily_text_access") != ""
      ) {
        var data = JSON.parse(
          localStorage.getItem("filters_search_daily_text_access")
        );
        this.filter = data.filter;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
      };
      localStorage.setItem(
        "filters_search_daily_text_access",
        JSON.stringify(filters)
      );
    },
    urlBuild: function () {
      this.saveDataOnStorage()
      let magazine_list_str = "";
      let client_list_str = "";
      if (this.filter.magazine_id != 0) {
        magazine_list_str += this.filter.magazine_id;
      }
      if (this.filter.client_id != 0) {
        client_list_str += this.filter.client_id;
      }

      let url =
        `clients=${client_list_str}&` +
        `magazines=${magazine_list_str}&` +
        (this.filter.start_date != ""
          ? `start_date=${this.filter.start_date}&`
          : "") +
        (this.filter.end_date != "" ? `end_date=${this.filter.end_date}&` : "");

      return url;
    },
    getMagazines: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazines_public?page[number]=1&page[size]=50`
        )
        .then((response) => {
          this.magazines = response.data.data;
          this.providerData();
        });
    },
    getCreateParams: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/system_access_log/create`)
        .then((data) => {
          this.magazines = data.data.magazines;
          this.clients = data.data.clients;
          this.providerData();
          bus.$emit("changeLoading", false);
        });
    },
    getDayTotalAccess: function (item) {
      let total = 0;
      item.texts.forEach((el) => {
        total += el.count_access;
      });

      return total;
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.daily-text-access {
  .form-group-edit {
    label {
      margin-right: 12px;
      font-size: 16px;
    }
  }
}

.default-table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  .main-tr {
    background-color: #e7e7e7;
  }
  .td-center {
    text-align: center;
  }
  .tr-hovered:hover {
    color: #212529;
    background-color: rgba(0, 0, 0, 0.075);
    cursor: pointer;
  }
  thead {
    th {
      padding: 0.75rem;
      vertical-align: bottom;
      border-bottom: 2px solid #dee2e6;
      border-top: 1px solid #dee2e6;
    }
  }
  td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }
}
</style>